// extracted by mini-css-extract-plugin
export default {"wrapper":"Breadcrumb_wrapper__Vyb4g","path":"Breadcrumb_path__NZOce","current":"Breadcrumb_current__PdkMs","icon":"Breadcrumb_icon__xOODB"};